import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { ECGCaptureResponseDto, ECGWaveFormResponseDto, ValueOf } from 'types/types';
import { getECGCapture, getPatientsECG, getFacilitiesEcg } from './actions';
import { DataStatus } from 'types/enums';

export interface State {
  status: ValueOf<typeof DataStatus>;
  ecgCapture: ECGWaveFormResponseDto[];
  patientsEcgCapture: null | PromiseSettledResult<ECGWaveFormResponseDto[]>[];
  analyzedECG: ECGCaptureResponseDto[];
}

const initialState: State = {
  status: DataStatus.IDLE,
  patientsEcgCapture: null,
  ecgCapture: [],
  analyzedECG: [],
};

const { reducer, actions } = createSlice({
  name: 'ecgCapture',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getECGCapture.fulfilled, (state, { payload }) => {
      state.ecgCapture = payload;
      state.status = DataStatus.SUCCEEDED;
    });
    builder.addCase(getPatientsECG.fulfilled, (state, { payload }) => {
      state.status = DataStatus.SUCCEEDED;
      state.patientsEcgCapture = payload;
    });
    builder.addCase(getECGCapture.rejected, (state) => {
      state.ecgCapture = [];
    });
    builder.addCase(getPatientsECG.rejected, (state) => {
      state.patientsEcgCapture = null;
    });
    builder.addCase(getFacilitiesEcg.fulfilled, (state, { payload }) => {
      state.analyzedECG = payload;
      state.status = DataStatus.SUCCEEDED;
    });
    builder.addCase(getFacilitiesEcg.rejected, (state) => {
      state.analyzedECG = [];
    });
    builder.addMatcher(isAnyOf(getECGCapture.pending, getPatientsECG.pending, getFacilitiesEcg.pending), (state) => {
      state.status = DataStatus.LOADING;
    });
    builder.addMatcher(isAnyOf(getECGCapture.rejected, getPatientsECG.rejected, getFacilitiesEcg.rejected), (state) => {
      state.status = DataStatus.FAILED;
    });
  },
});

export { reducer, actions };
